import _ from 'underscore';
import { removeObject } from "../../utils";
import moment from 'moment';

import {
  ADD_ITEM_SHOPPING_CART, REMOVE_ITEM_SHOPPING_CART,
  LOAD_ITEMS_SHOPPING_CART, ADD_OBSERVATIONS_TO_CARTITEM,
  SHOW_MODAL_CART_ELEMENT, ACTIVATE_EXTRA_CART_ELEMENT,
  CLEAN_SHOPPING_CART_STORE,
  CHANGE_CLIENT_CHARGE_SERVICE_SUCCESS,
  TOGGLE_ADDITIONAL_SERVICE
} from './actions';

const initialState = {
  totalPrice: undefined,
  items: [],
  extras: [],
  forfait: true,
  modal: {
    show: false,
    content: null,
  }
}

// Return true if all the elements have price, otherwise returns false
const checkForfait = items => _.every(items, e => typeof e.price !== 'undefined' && e.price !== null);

export default function (state = initialState, action) {
  let items = [...state.items];
  let payload = action.payload;
  let forfait = state.forfait;
  let itemsResult;
  let cleaned = {};

  switch (action.type) {
    case ACTIVATE_EXTRA_CART_ELEMENT:
      let serviceId = action.payload.extra.serviceId;
      _.each(items, (item) => {
        let extra = _.findWhere(item.extras, { serviceId });
        if (extra) {
          extra.activate = !extra.activate;
        }
      });
      return {
        ...state,
        items,
      }
    case TOGGLE_ADDITIONAL_SERVICE:
      const additionalService = action.payload.additionalService;
      const additionalServiceIndex = _.findIndex(items, e => e.serviceId === additionalService.serviceId)

      if(additionalServiceIndex === -1){
        items.push(additionalService)
      }else{
        items.splice(additionalServiceIndex,1);
      }

      return {
        ...state,
        items,
      }

    case SHOW_MODAL_CART_ELEMENT:
      return {
        ...state,
        modal: {
          show: action.payload.show,
          content: action.payload.content,
        }
      }
    case ADD_OBSERVATIONS_TO_CARTITEM:
      let element = _.findWhere(items, { serviceId: action.payload.item.serviceId })
      element.observations = action.payload.observations;
      return {
        ...state,
        items,
      }
    case ADD_ITEM_SHOPPING_CART:
      itemsResult = [...items, action.payload.item];
      // if(typeof payload.item.price === 'undefined') forfait = false;
      forfait = checkForfait(itemsResult);
      return {
        ...state,
        items: itemsResult,
        forfait: forfait,
      }
    case REMOVE_ITEM_SHOPPING_CART:
        itemsResult = removeObject(items, '_id', payload.serviceId);
      forfait = checkForfait(itemsResult);
      return {
        ...state,
        items: itemsResult,
        forfait,
      }
    case LOAD_ITEMS_SHOPPING_CART:
      return {
        ...state,
        items: payload.budget.budgetLines,
        //forfait: payload.budget.forfait
      }
    case CLEAN_SHOPPING_CART_STORE:
      if (action.payload.props === '*') {
        cleaned = initialState;
      } else if (Array.isArray(action.payload.props)) {
        action.payload.props.forEach(p => {
          cleaned[p] = initialState[p]
        });
      }
      return {
        ...state,
        ...cleaned,
      }

    case CHANGE_CLIENT_CHARGE_SERVICE_SUCCESS:
      const { index, whoPays } = action.payload;
      const item = items[index];
      item.whoPays = whoPays;
      item.noPaid = !!whoPays;
      if (whoPays) {
        item.originalPrice = item.price;
        item.price = 0;
        item.ivaPrice = 0;
      } else {
        item.price = item.originalPrice ? item.originalPrice : item.price;
        item.ivaPrice = item.originalPrice ? Number(parseFloat(item.originalPrice * 1.21).toFixed(2)) : item.ivaPrice;
      }
      items[index] = item;
      return {
        ...state,
        items,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/shoppingCart/reducer.js